import moment from "moment";

interface gamelistInf {
  [key: string]: gameInf;
}

interface gameInf {
  id: string;
  status: string;
  startDay: number;
  startTime: number | string;
}

export default function sortGamesByStartTime(games: gamelistInf): string[] {
  let runningKeys: string[] = [];
  const delayedKeys: string[] = [];
  const KeyMap: { [key: string]: string } = {};
  let i = 0;
  for (const [key, value] of Object.entries(games)) {
    if (value.status === "Running") {
      runningKeys.push(key);
    } else if (value.status === "Delayed") {
      delayedKeys.push(key);
    } else {
      const startTimeStr = typeof value.startTime === 'string' ? value.startTime : value.startTime.toString();
      const time =
        value.startDay + moment(startTimeStr, "hh:mm a").format("HH:mm") + i;
      KeyMap[time] = key;
    }
    i++;
  }

  runningKeys = [...runningKeys, ...delayedKeys];

  const date = new Date();
  const day = date.getDay();
  const time = moment(date).format("HH:mm");
  const now = day + time;

  const sortedKeys = Object.keys(KeyMap).sort();
  const rotatedKeys: string[] = [];
  for (let i = 0; i < sortedKeys.length; i++) {
    const key = sortedKeys[i];
    if (key <= now) {
      rotatedKeys.push(KeyMap[key]);
    } else {
      runningKeys.push(KeyMap[key]);
    }
  }

  return [...runningKeys, ...rotatedKeys];
}
